<template>
  <main-header />
  <main :class="['mobile-page-shell', { 'mobile-subpage-shell': $route.name !== 'mobileMain' }]">
    <router-view :key="$route.fullPath"></router-view>
  </main>
  <slot-list v-if="isSlotOpen" :groupCode="groupCode" :codeName="codeName" @isSlot="isSlotOpen = false"></slot-list>
  <loading></loading>
</template>

<script>

import MainHeader from './Header'
import SlotList from '@/components/game/SlotList'
import Loading from '@/components/common/Loading.vue'

export default {
  name: 'MobileDefaultLayout',
  components: {
    SlotList,
    MainHeader,
    Loading
  },
  mounted () {
    this.emitter.on('isSlot', (data) => {
      if (data) {
        const groupCode = data.groupCode
        const codeName = data.codeName
        this.getSlotOpen(groupCode, codeName)
      } else {
        this.isSlotOpen = false
      }
    })
  },
  data () {
    return {
      isSlotOpen: false,
      groupCode: '',
      codeName: ''
    }
  },
  methods: {
    getSlotOpen (groupCode, codeName) {
      if (this.userData) {
        this.groupCode = groupCode
        this.codeName = codeName
        this.isSlotOpen = true
      } else {
        // this.onCheck('front.error.afterSignin')
        alert(this.$t('front.error.afterSignin'))
      }
    }
  }
}
</script>

<style>
.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 0.2s ease-in;
}

.fade-leave-active {
  transition: opacity 0.1s ease-in;
}

.fade-leave-to {
  opacity: 0;
}

.slide-fade-enter {
  transform: translateX(10px);
  opacity: 0;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.2s ease;
}

.slide-fade-leave-to {
  transform: translateX(-10px);
  opacity: 0;
}

.slide-up-enter {
  transform: translateY(185px);
  opacity: 0;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease;
}

.slide-up-leave-to {
  transform: translateY(0px);
  opacity: 0;
}

/* MEGA mobile subpages */
.mobile-page-shell,
.mobile-page-shell * {box-sizing:border-box}
.mobile-page-shell {
  width:100%;
  min-width:0;
  max-width:100%;
  min-height:100vh;
  background:#0c0c0e;
}
.mobile-page-shell img,
.mobile-page-shell input,
.mobile-page-shell select,
.mobile-page-shell textarea {max-width:100%}
.mobile-page-shell input,
.mobile-page-shell select,
.mobile-page-shell textarea,
.mobile-page-shell li,
.mobile-page-shell a,
.mobile-page-shell span {min-width:0}
.mobile-page-shell:not(.mobile-subpage-shell) {min-height:0}
.mobile-subpage-shell {
  width:100%;
  min-width:0;
  max-width:100%;
  min-height:calc(100vh - 58px);
  padding-bottom:66px;
  background:#0c0c0e;
  color:#eeeae5;
  box-sizing:border-box;
}
.mobile-subpage-shell .head {
  position:relative;
  top:auto;
  left:auto;
  width:100%;
  height:54px;
  padding:0 16px;
  border-bottom:1px solid #29292d;
  background:#101011;
  box-sizing:border-box;
}
.mobile-subpage-shell .head a {justify-content:flex-start}
.mobile-subpage-shell .head h2 {gap:8px;color:#eeeae5;font-size:17px;font-weight:700}
.mobile-subpage-shell .head h2 img {width:20px;max-height:20px;opacity:.8}
.mobile-subpage-shell .head h2 span {flex-direction:row;align-items:baseline;gap:7px}
.mobile-subpage-shell .head h2 em {display:inline;color:#76736f;font-size:9px;text-transform:uppercase}
.mobile-subpage-shell .sub-box {
  width:100%;
  min-width:0;
  max-width:100%;
  min-height:calc(100vh - 112px);
  padding:14px 16px 30px;
  background:#0c0c0e;
  background-image:none!important;
  box-sizing:border-box;
}
.mobile-subpage-shell .moneytab {
  height:46px;
  margin:0 0 18px;
  gap:20px;
  border-bottom:1px solid #29292d;
}
.mobile-subpage-shell .moneytab a {
  position:relative;
  width:auto;
  height:46px;
  padding:0 2px;
  border:0;
  border-radius:0;
  background:transparent;
  color:#817e79;
  text-shadow:none;
}
.mobile-subpage-shell .moneytab a span {font-size:11px;white-space:nowrap}
.mobile-subpage-shell .moneytab a.on {background:transparent;color:#eeeae5}
.mobile-subpage-shell .moneytab a.on::after {
  content:'';
  position:absolute;
  right:0;
  bottom:-1px;
  left:0;
  height:2px;
  background:#a98d57;
}
.mobile-subpage-shell .state {
  width:100%;
  height:auto;
  margin:0 0 10px;
  padding:12px 14px;
  border:1px solid #302f30;
  border-radius:7px;
  background:#141416;
  color:#96918b;
  font-size:10px;
}
.mobile-subpage-shell .state,
.mobile-subpage-shell .topbox,
.mobile-subpage-shell .moneyread,
.mobile-subpage-shell .pointinwrap,
.mobile-subpage-shell .datewrap,
.mobile-subpage-shell .gamebetlist,
.mobile-subpage-shell .msgwrap,
.mobile-subpage-shell .msgwrap>*,
.mobile-subpage-shell .board,
.mobile-subpage-shell .boardw {
  width:100%;
  min-width:0;
  max-width:100%;
}
.mobile-subpage-shell .topbox {
  margin:0;
  padding:18px;
  border:1px solid #302f30;
  border-radius:8px;
  background:#141416;
  align-items:stretch;
}
.mobile-subpage-shell .topbox>img {display:none}
.mobile-subpage-shell .appliwrite input,
.mobile-subpage-shell .outmoneywrite input,
.mobile-subpage-shell .servicewriteinput input,
.mobile-subpage-shell .servicewriteinput textarea,
.mobile-subpage-shell .myinfoinput li+li {
  border:1px solid #302f30;
  border-radius:6px;
  background:#101012;
  box-shadow:none;
  color:#eeeae5;
}
.mobile-subpage-shell .appliwrite input {height:44px}
.mobile-subpage-shell .applihave {color:#8f8b87}
.mobile-subpage-shell .applimoneybtn {margin-top:12px;gap:6px}
.mobile-subpage-shell .applimoneybtn li {
  height:36px;
  border:1px solid #343334;
  border-radius:6px;
  background:#1b1b1d;
  color:#c7c1ba;
  text-shadow:none;
}
.mobile-subpage-shell .btnwrap {margin:16px 0 24px}
.mobile-subpage-shell .btnwrap a,
.mobile-subpage-shell .sbtnwrap a {
  height:40px;
  border:1px solid #8a7042;
  border-radius:7px;
  background:#8a7042;
  color:#f5f1e9;
  text-shadow:none;
  font-size:12px;
}
.mobile-subpage-shell .moneyread {
  margin-top:16px;
  padding:18px;
  border:1px solid #302f30;
  border-radius:8px;
  background:#141416;
}
.mobile-subpage-shell .moneyread h3 {margin:0 0 12px;justify-content:flex-start;color:#d0bc91;font-size:12px}
.mobile-subpage-shell .moneyread ul {gap:0}
.mobile-subpage-shell .moneyread ul li {padding:6px 0;background:transparent;color:#8f8b87;font-size:10px}
.mobile-subpage-shell .pointinwrap {
  margin:0 0 14px;
  padding:18px;
  border:1px solid #302f30;
  border-radius:8px;
  background:#141416;
}
.mobile-subpage-shell .havepointwrap li {padding:8px 0;border-bottom:1px solid #29292d}
.mobile-subpage-shell .havepointwrap li:last-child {border-bottom:0}
.mobile-subpage-shell .havepointwrap li p {height:auto;background:transparent;color:#8f8b87}
.mobile-subpage-shell .havepointwrap li p span {color:#d2bd91}
.mobile-subpage-shell .datewrap {
  margin-top:14px;
  padding:14px;
  border:1px solid #302f30;
  border-radius:8px;
  background:#141416;
}
.mobile-subpage-shell .datewrap ul,
.mobile-subpage-shell .datewrap li,
.mobile-subpage-shell .havepointwrap,
.mobile-subpage-shell .havepointwrap li,
.mobile-subpage-shell .appliwrite,
.mobile-subpage-shell .outmoneywrite {min-width:0;max-width:100%}
.mobile-subpage-shell .datewrap li input,
.mobile-subpage-shell .datewrap li select,
.mobile-subpage-shell .dateperiod {border:1px solid #302f30;background:#101012;color:#eeeae5}
.mobile-subpage-shell .gamebetwrap {gap:8px;margin:14px 0}
.mobile-subpage-shell .gamebetlist {
  padding:14px;
  border:1px solid #302f30;
  border-radius:7px;
  background:#141416;
  box-shadow:none;
  color:#a8a39e;
}
.mobile-subpage-shell .msgwrap {gap:8px}
.mobile-subpage-shell .msgwrap ul,
.mobile-subpage-shell .msgwrap ul.notice,
.mobile-subpage-shell .msgwrap ul.event {
  min-height:64px;
  padding:14px;
  border:1px solid #302f30;
  border-radius:7px;
  background:#141416;
  box-shadow:none;
}
.mobile-subpage-shell .msgwrap ul.notice,
.mobile-subpage-shell .msgwrap ul.event {padding-left:14px;background-image:none}
.mobile-subpage-shell .msgwrap ul.notice .subject,
.mobile-subpage-shell .msgwrap ul.event .subject,
.mobile-subpage-shell .msgwrap .subject {color:#eeeae5;font-size:12px}
.mobile-subpage-shell .noticeicon,
.mobile-subpage-shell .eventicon {
  border-radius:4px;
  background:#6f5a35;
  color:#f4efe5;
  font-size:9px;
}
.mobile-subpage-shell .newicon {border-radius:3px;background:#704747;font-size:8px}
.mobile-subpage-shell .freeboardtop {height:auto;margin:0 0 10px;padding:12px 14px;border-radius:6px;background:#171718;font-size:11px}
.mobile-subpage-shell .searchselect,
.mobile-subpage-shell .searchinput {border:1px solid #302f30;border-radius:6px;background:#141416;color:#eeeae5}
.mobile-subpage-shell .searchicon {height:38px;border:1px solid #8a7042;border-radius:6px;background:#8a7042;text-shadow:none;font-size:12px}
.mobile-subpage-shell .msgreadconwrap {border-top-color:#302f30;color:#aaa6a1}
.mobile-subpage-shell .msgreadconname {border-bottom-color:#302f30;color:#eeeae5}
.mobile-subpage-shell .paging {margin-bottom:16px}
.mobile-subpage-shell .paging a.on {border-color:#8a7042;background:#8a7042}
</style>
